var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganizationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 22V33.1445C42 34.8686 42 35.7307 41.8676 36.4493C41.2664 39.7129 38.7129 42.2665 35.4493 42.8676C34.7307 43 33.8686 43 32.1444 43H30.0518C29.6995 43 29.3626 42.8554 29.1199 42.5999L24.275 37.5M24.275 37.5L27.5879 34.3448C28.4896 33.4861 29 32.2801 29 31.0349C29 28.5496 26.9853 26.5 24.5 26.5C22.0147 26.5 20 28.5147 20 31V31.1453C20 32.3361 20.4573 33.4814 21.2774 34.3447L24.275 37.5ZM24.275 37.5L18.8666 42.6509C18.6313 42.875 18.3187 43 17.9938 43H16C14.1414 43 13.2121 43 12.4393 42.8463C9.26575 42.215 6.78497 39.7343 6.15372 36.5607C6 35.7879 6 34.8586 6 33V24.5448C6 22.1472 6 20.9485 6.31955 19.852C6.60253 18.8811 7.06705 17.9726 7.6885 17.1747C8.39025 16.2737 9.36207 15.5719 11.3057 14.1681L19.5 8.25002C22.1863 6.30989 25.8137 6.30989 28.5 8.25002",
    stroke: "#202124",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9324 7.33167C34.9475 7.25793 35.0529 7.25793 35.0679 7.33167C35.8502 11.1591 38.8413 14.1501 42.6687 14.9324C42.7424 14.9475 42.7424 15.0529 42.6687 15.0679C38.8413 15.8502 35.8502 18.8413 35.0679 22.6687C35.0529 22.7424 34.9475 22.7424 34.9324 22.6687C34.1501 18.8413 31.1591 15.8502 27.3317 15.0679C27.2579 15.0529 27.2579 14.9475 27.3317 14.9324C31.1591 14.1501 34.1501 11.1591 34.9324 7.33167Z",
    stroke: "#5200FF",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4374 2.75215C43.5626 2.13991 44.4374 2.13991 44.5625 2.75215C44.8389 4.10434 45.8956 5.16106 47.2478 5.43744C47.86 5.56258 47.86 6.43735 47.2478 6.56249C45.8956 6.83887 44.8389 7.89559 44.5625 9.24778C44.4374 9.86002 43.5626 9.86002 43.4374 9.24778C43.1611 7.89559 42.1043 6.83887 40.7521 6.56249C40.1399 6.43735 40.1399 5.56258 40.7521 5.43744C42.1043 5.16106 43.1611 4.10434 43.4374 2.75215Z",
    fill: "#5200FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationIcon);
export default __webpack_public_path__ + "static/media/organization-icon.a4194e0296d769fc43d3d70a125c743f.svg";
export { ForwardRef as ReactComponent };